export function parseFirstNameUpperCase (fullName) {
  let firstLetterUpperCaseName = ''
  let fullNameArray = fullName.toLowerCase().split(' ')
  let fullNameFinal = []
  fullNameArray.map((name) => {
    firstLetterUpperCaseName = name.charAt(0).toUpperCase() + name.slice(1)
    fullNameFinal.push(firstLetterUpperCaseName)
  })

  return fullNameFinal.join(' ').toString()
}



// WEBPACK FOOTER //
// ./src/utils/parseFirstNameUpperCase.js